import type { ClientTheme } from "@/app/lib/themes"

/**
 * Shared button styles. Two sizes:
 *  - primary/secondary: standard actions (~34px tall, matches controlBase inputs)
 *  - compact: table-toolbar actions (~28px tall)
 * Colours are inline styles because they read runtime theme values.
 */

export function primaryButton(theme: ClientTheme): React.CSSProperties {
  return {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontFamily: "var(--font-ui)",
    fontSize: "13px",
    fontWeight: 600,
    padding: "8px 16px",
    borderRadius: "8px",
    backgroundColor: theme.brandPrimary,
    color: theme.textOnBrand,
    border: "none",
    cursor: "pointer",
  }
}

export function secondaryButton(theme: ClientTheme): React.CSSProperties {
  return {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontFamily: "var(--font-ui)",
    fontSize: "13px",
    fontWeight: 500,
    padding: "8px 16px",
    borderRadius: "8px",
    backgroundColor: theme.bgSurface2,
    color: theme.textMuted,
    border: `1px solid ${theme.borderColor}`,
    cursor: "pointer",
  }
}

export function compactButton(theme: ClientTheme): React.CSSProperties {
  return {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontFamily: "var(--font-ui)",
    fontSize: "12px",
    fontWeight: 600,
    padding: "6px 12px",
    borderRadius: "8px",
    backgroundColor: theme.bgSurface2,
    color: theme.textMuted,
    border: `1px solid ${theme.borderColor}`,
    cursor: "pointer",
  }
}
